// Thư mục: src/stores/driverBaoDuongStore.js
import { defineStore } from "pinia";
// Import service với tên object
import { BaoDuongXeApi } from "@/services/baoDuongXeService";

export const useDriverBaoDuongStore = defineStore("driverBaoDuong", {
  state: () => ({
    isLoading: false, // Loading danh sách
    error: null, // Lỗi tải danh sách
    tickets: [], // Danh sách phiếu của tài xế

    // State cho modal chi tiết hoặc action
    isLoadingDetail: false,
    detailError: null,
    currentTicket: null, // Phiếu đang xem (nếu dùng modal)
  }),

  getters: {
    // Getter lấy phiếu đang chờ xử lý (ví dụ)
    pendingTickets(state) {
      return state.tickets.filter(
        (t) =>
          t.trangThai === "MOI" ||
          t.trangThai === "DA_DUYET" ||
          t.trangThai === "DANG_SUA"
      );
    },
  },

  actions: {
    // --- Tải danh sách phiếu của tôi ---
    async fetchTickets() {
      this.isLoading = true;
      this.error = null;
      try {
        const data = await BaoDuongXeApi.getDriverTickets();
        // Sắp xếp: ưu tiên phiếu MỚI, CHỜ DUYỆT, ĐANG SỬA lên đầu
        this.tickets = (data || []).sort((a, b) => {
          const getOrder = (status) => {
            switch (status) {
              case "MOI":
                return 1;
              case "CHO_DUYET":
                return 2;
              case "DA_DUYET":
                return 3;
              case "DANG_SUA":
                return 4;
              case "CHO_THANH_TOAN":
                return 5;
              case "HOAN_THANH":
                return 6;
              case "DA_HUY":
                return 7;
              default:
                return 8;
            }
          };
          return getOrder(a.trangThai) - getOrder(b.trangThai);
        });
      } catch (e) {
        this.error =
          e?.response?.data?.message ||
          e?.message ||
          "Lỗi tải danh sách phiếu sửa chữa";
        console.error("fetchDriverTickets error:", e);
      } finally {
        this.isLoading = false;
      }
    },

    // --- Tải chi tiết 1 phiếu (nếu cần) ---
    async openTicketDetail(ticketId) {
      this.isLoadingDetail = true;
      this.detailError = null;
      this.currentTicket = null;
      try {
        this.currentTicket = await BaoDuongXeApi.getById(ticketId);
      } catch (e) {
        this.detailError =
          e?.response?.data?.message || e?.message || "Lỗi tải chi tiết phiếu";
      } finally {
        this.isLoadingDetail = false;
      }
    },
    clearTicketDetail() {
      this.currentTicket = null;
      this.detailError = null;
    },

    // --- CÁC HÀNH ĐỘNG CỦA TÀI XẾ ---

    /**
     * Tạo phiếu từ SOS (gọi từ SosComponent)
     */
    async createTicketFromSos(payload) {
      this.isLoadingDetail = true;
      this.detailError = null;
      try {
        const newTicket = await BaoDuongXeApi.createFromSos(payload);
        await this.fetchTickets(); // Tải lại danh sách sau khi tạo SOS
        return newTicket;
      } catch (e) {
        this.detailError =
          e?.response?.data?.message || e?.message || "Lỗi gửi báo cáo sự cố";
        console.error("createTicketFromSos error:", e);
        throw e;
      } finally {
        this.isLoadingDetail = false;
      }
    },

    /**
     * Tài xế gửi báo giá
     */
    async driverSubmitGia(ticketId, payload) {
      this.isLoadingDetail = true;
      this.detailError = null;
      try {
        await BaoDuongXeApi.submitBaoGia(ticketId, payload);
        await this.fetchTickets(); // Tải lại cả list
      } catch (e) {
        this.detailError =
          e?.response?.data?.message || e?.message || "Lỗi gửi báo giá";
        console.error("driverSubmitGia error:", e);
        throw e;
      } finally {
        this.isLoadingDetail = false;
      }
    },

    /**
     * Tài xế bấm bắt đầu sửa
     */
    async driverStartSuaChua(ticketId) {
      this.isLoadingDetail = true;
      this.detailError = null;
      try {
        await BaoDuongXeApi.batDauSuaChua(ticketId);
        await this.fetchTickets(); // Tải lại cả list
      } catch (e) {
        this.detailError =
          e?.response?.data?.message ||
          e?.message ||
          "Lỗi khi bắt đầu sửa chữa";
        console.error("driverStartSuaChua error:", e);
        throw e;
      } finally {
        this.isLoadingDetail = false;
      }
    },

    /**
     * Tài xế gửi xác nhận hoàn thành
     */
    async driverCompleteSuaChua(ticketId, payload) {
      this.isLoadingDetail = true;
      this.detailError = null;
      try {
        await BaoDuongXeApi.hoanThanhSuaChua(ticketId, payload);
        await this.fetchTickets(); // Tải lại cả list
      } catch (e) {
        this.detailError =
          e?.response?.data?.message || e?.message || "Lỗi xác nhận hoàn thành";
        console.error("driverCompleteSuaChua error:", e);
        throw e;
      } finally {
        this.isLoadingDetail = false;
      }
    },
  },
});
